import Footer from "../component/footer";
import Navbar from "../component/navbar";

export default function Contact() {
  return (
    <>
      <Navbar />
      <div className="max-w-5xl  w-screen h-[600px] mx-auto flex flex-col justify-center items-center">
        <div className=" px-10 py-10 md:px-20 md:py-20 w-full ">
          <div className="flex flex-col gap-2">
            <span className="text-[#9e76b4] text-3xl font-medium">
              ติดต่อสอบถาม
            </span>
            <div
              onClick={() => window.open("mailto:saraban_vet@cmu.ac.th")}
              className="cursor-pointer text-xl hover:text-[#9e76b4] transition-all duration-300 ease-in-out flex items-center gap-3 "
            >
              <i className="fa-regular fa-envelope"></i> saraban_vet@cmu.ac.th
            </div>
            <div className="flex  text-xl  items-center gap-3">
              <i className="fa fa-phone"></i>
              <span
                onClick={() => window.open("tel:053948026")}
                className="cursor-pointer hover:text-[#9e76b4] transition-all duration-300 ease-in-out"
              >
                053-948-026
              </span>
              ,
              <span
                onClick={() => window.open("tel:053948002")}
                className="cursor-pointer hover:text-[#9e76b4] transition-all duration-300 ease-in-out"
              >
                053-948-002
              </span>
            </div>
          </div>

          <hr className="border-t-2 border-[#9e76b43b]" />
          <div className="flex flex-col gap-3">
            <div className="text-xl font-medium text-[#9e76b4]">Map</div>
            <div className="w-full rounded-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7526.249925158489!2d98.940243!3d18.758793!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30da30c0ebfaa375%3A0x5b64ddd9d837c316!2sFaculty%20of%20Veterinary%20Medicine%2C%20Chiang%20Mai%20University!5e1!3m2!1sen!2sth!4v1736753420307!5m2!1sen!2sth"
                className="w-full h-[300px]"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
